<template>
    <div>
        <v-divider class="my-2"></v-divider>
        <loading-gdb :propObject="StateInfoAlunoLoading" text="Pesquisando RA..." />
        <v-row>
            <v-col cols="12" sm="6">
                <v-form v-on:submit.prevent="GetInfoAluno({ra:search})" ref="form_search_user">
                    <!-- TODO: @input mudou para @update:modelValue -->
                    <v-text-field v-mask="'###-######'"
                        hide-details
                        :disabled="StateInfoAlunoLoading"
                        :loading="StateInfoAlunoLoading"
                        v-model="search"
                        @input="($event||'').length === 10 ? GetInfoAluno({ra:search}) : ''"
                        autofocus clearable tile
                        :rules="[ v => !!v || 'Campo obrigatório', v => (v || '').length === 10  || 'RA inválido']"
                        maxlength="10" :counter="10"
                        label="Pesquisar RA..."
                        >
                            <template v-slot:append>
                                <v-btn icon @click.stop="GetInfoAluno({ra:search})">
                                    <v-icon>mdi-account-search</v-icon>
                                </v-btn>
                            </template>
                    </v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <v-row>
            <v-col cols="12">
                <div v-if="'aluno' in StateInfoAluno">
                    <div>{{StateInfoAluno.aluno.NOME}}</div>
                    <div class="text-disabled mb-2">{{StateInfoAluno.aluno.EMAIL}}</div>
                    <div>Registro Acadêmico: <span class="text-success">{{StateInfoAluno.aluno.RA}}</span></div>
                    <v-divider class="my-2"></v-divider>
                    <div>
                        <div>
                            <div class="text-h6">FILIAIS VINCULADAS</div>
                            <v-alert text
                                v-for="filial,index in StateInfoAluno.filiais"
                                :key="index"
                                color="primary" >
                                <span v-if="StateInfoAluno.filiais.length > 0">
                                    {{filial.FANTASIA}}<br>
                                    <strong>{{filial.TIPOCURSO}}</strong>
                                </span>
                            </v-alert>
                            <div class="my-2" v-if="StateInfoAluno.filiais.length === 0">
                                <v-alert text color="error">
                                    Atenção! Usuário não está relacionado a nenhuma filial. Entre em contato com o departamento CIT para parametrização do usuário
                                </v-alert>
                            </div>
                        </div>
                        <v-divider class="my-2"></v-divider>
                        <div v-if="StateInfoAluno.usuario">
                            <div>Usuário de Acesso:
                                <span :class="StateInfoAluno.aluno.RA === StateInfoAluno.aluno.CODUSUARIO ? 'text-success' : 'red--text'">
                                    {{StateInfoAluno.aluno.CODUSUARIO}}
                                </span>
                            </div>
                            <div>
                                <div v-if="!StateInfoAluno.usuario.ACTIVE" class="text-error">
                                    <strong>Clique para ativar</strong>
                                </div>
                                <v-chip label pill
                                    :disabled="StateInfoAluno.usuario.ACTIVE || StateInfoAlunoLoading"
                                    @click.stop="StateInfoAluno.usuario?.ACTIVE == 0
                                                        ? AtivaUserAluno({user: StateInfoAluno.usuario.USERNAME})
                                                        : ''"
                                    :color="StateInfoAluno.usuario.ACTIVE == 1 ? 'success':'red'" >
                                    {{StateInfoAluno.usuario.ACTIVE == 1? 'Já está ativo':'Reativar Usuário' }}
                                </v-chip>
                            </div>
                            <div v-if="'gpermis' in StateInfoAluno" class="my-2">
                                <v-alert v-if="!StateInfoAluno.gpermis"
                                    color="error" elevation="0" >
                                    <span>Usuário não está ativo no Sistema Educacional! Entre em contato com o CIT para melhor análise!</span>
                                </v-alert>
                            </div>
                            <div v-if="!(StateInfoAluno.aluno.RA === StateInfoAluno.aluno.CODUSUARIO)" class="my-2">
                                <v-alert color="error" elevation="0" >
                                    <span>Atenção! RA é diferente do usuário de acesso.</span>
                                </v-alert>
                            </div>
                        </div>
                        <div v-else>
                            <v-alert color="error" elevation="0" >
                                <span>Nenhum usuário vinculado para o Aluno</span>
                            </v-alert>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props:{
        title:{
            default: '-'
        },
    },
    data:()=>({
        search:'',
    }),
    methods:{
        ...mapActions(['GetInfoAluno', 'AtivaUserAluno']),
    },
    computed:{
        ...mapGetters(['StateInfoAluno','StateInfoAlunoLoading'])
    },
    // watch: {
    //     search:{
    //         handler(pesquisa){
    //             if (pesquisa){
    //                 // Adicionar o hífen automaticamente
    //                 if(pesquisa.indexOf('-') < 0 && pesquisa.length >= 3){
    //                     let mascaraRa =  pesquisa.substr(0,3)+"-"+pesquisa.substr(3);
    //                     this.search = mascaraRa
    //                 }
    //             }
    //         },deep:true
    //     }
    // }
}
</script>